import { OrgTypes } from './organizationUtils';

export const GPNOrgTypes = {
  CORP: 0,
  REGION: 1,
  PRINCIPAL: 2,
  ASSOCIATE: 3,
  CHAIN: 4,
  MERCHANT: 5,
};
export const HPYOrgTypes = {
  CHAIN: 0,
  MERCHANT: 1,
};
export const EVOOrgTypes = {
  GROUP :0,
  CHAIN: 1,
  TAXID: 2,
  MERCHANT: 3,
};
export const GPEOrgTypes = {
  OPCO: 0,
  ACQUIRER: 1,
  CONTRACT: 2,
  MERCHANT: 3,
};

export const gpnLevelConfig = [
  { currentLevel: 'level6', nextLevel: 'level5', name: 'region', stateLevel: 1 },
  { currentLevel: 'level5', nextLevel: 'level4', name: 'principal', stateLevel: 2 },
  { currentLevel: 'level4', nextLevel: 'level3', name: 'associate', stateLevel: 3 },
  { currentLevel: 'level3', nextLevel: 'level2', name: 'chain', stateLevel: 4 },
  { currentLevel: 'level2', nextLevel: 'level1', name: 'merchant', stateLevel: 5 },
];
export const evoLevelConfig = [
  { currentLevel: 'level4', nextLevel: 'level3', name: 'chain', stateLevel: 1 },
  { currentLevel: 'level3', nextLevel: 'level2', name: 'tax_id', stateLevel: 2 },
  { currentLevel: 'level2', nextLevel: 'level1', name: 'merchant', stateLevel: 3 },
];  
export const hpyLevelConfig = [
  { currentLevel: 'level2', nextLevel: 'level1', name: 'merchant', stateLevel: 1 },
];
export const gpeLevelConfig = [
  { currentLevel: 'level4', nextLevel: 'level3', name: 'acquirer', stateLevel: 1 },
  { currentLevel: 'level3', nextLevel: 'level2', name: 'contract', stateLevel: 2 },
  { currentLevel: 'level2', nextLevel: 'level1', name: 'merchant', stateLevel: 3 },
];
// corp=0, region=1, principal=2, associate=3, chain=4
const gpnhierarchyCodeLengths = [3, 5, 8, 11, 14];
const gpnhierarchyCodeTierNames = ['corp', 'region', 'principal', 'associate', 'chain', 'merchant'];
const evohierarchyCodeTierNames = ['chain', 'group', 'taxid', 'merchant'];
const hpyhierarchyCodeTierNames = ['chain','merchant'];
const gpehierarchyCodeTierNames = ['opco', 'acquirer', 'contract', 'merchant'];

// generate a hierarchyCode given the segments and org type
export const gpngenerateHierarchyCode = ({ type, corp, region, principal, associate, chain }) => {
  const fullCode = (corp || '') + (region || '') + (principal || '') + (associate || '') + (chain || '');
  const typeIndex = gpnhierarchyCodeTierNames[type.toLowerCase()];
  return fullCode.slice(0, gpnhierarchyCodeLengths[typeIndex]);
};

// convert org name to org type
export const getGpnOrgType = ({ type }) => {
  return GPNOrgTypes[type.toUpperCase()];
};

export const getGpnOrgName = (orgType) => {
  return gpnhierarchyCodeTierNames[orgType];
};

export const getHpyOrgName=(orgType)=>{
    return hpyhierarchyCodeTierNames[orgType];
}
export const getEvoOrgName=(orgType)=>{
    return evohierarchyCodeTierNames[orgType];
}
export const getGpeOrgName=(orgType)=>{
  return gpehierarchyCodeTierNames[orgType];
}

// given a hierarchyCode, return the hierarchyCode of the ancestor of the requested type
export const getAncestorHierarchyCode = (orgType, descendantHierarchyCode) => {
  return descendantHierarchyCode ? descendantHierarchyCode.slice(0, gpnhierarchyCodeLengths[orgType]) : null;
};

export const getGpnOrgLabelFromHierarchyCode = (orgType, hierarchyCode) => {
  if (orgType === GPNOrgTypes.CORP) return hierarchyCode;
  const start = gpnhierarchyCodeLengths[orgType - 1];
  return hierarchyCode.slice(start);
};

export const getGPNLowestHierarchyLevel = (organizationContent) => {
  if (organizationContent === undefined || organizationContent.length === 0) {
    return '';
  }
  const organizationTypes = organizationContent
    .map((element) => {
      return GPNOrgTypes[element.type.toUpperCase()];
    })
    .filter(checkIfUnique)
    .sort((a, b) => b - a);
  return gpnhierarchyCodeTierNames[organizationTypes[0]].toUpperCase();
};

function checkIfUnique(value, index, self) {
  return self.indexOf(value) === index;
}

export function getBlankHierarchyRow(key) {
  return {
    key,
    selectedOrgIds: [],
    row: [
      { items: [], isLoading: false, selectedItems: [], tierName: 'corp', orgType: OrgTypes.CORP },
      { items: [], isLoading: false, selectedItems: [], tierName: 'region', orgType: OrgTypes.REGION },
      { items: [], isLoading: false, selectedItems: [], tierName: 'principal', orgType: OrgTypes.PRINCIPAL },
      { items: [], isLoading: false, selectedItems: [], tierName: 'associate', orgType: OrgTypes.ASSOCIATE },
      { items: [], isLoading: false, selectedItems: [], tierName: 'chain', orgType: OrgTypes.CHAIN },
      { items: [], isLoading: false, selectedItems: [], tierName: 'merchant', orgType: OrgTypes.MERCHANT },
    ],
  };
}

export function getBlankHierarchyRowGpn(key) {
  return {
    key,
    selectedOrgIds: [],
    row: [
      { items: [], isLoading: false, selectedItems: [], tierName: 'corp', orgType: GPNOrgTypes.CORP },
      { items: [], isLoading: false, selectedItems: [], tierName: 'region', orgType: GPNOrgTypes.REGION },
      { items: [], isLoading: false, selectedItems: [], tierName: 'principal', orgType: GPNOrgTypes.PRINCIPAL },
      { items: [], isLoading: false, selectedItems: [], tierName: 'associate', orgType: GPNOrgTypes.ASSOCIATE },
      { items: [], isLoading: false, selectedItems: [], tierName: 'chain', orgType: GPNOrgTypes.CHAIN },
      { items: [], isLoading: false, selectedItems: [], tierName: 'merchant', orgType: GPNOrgTypes.MERCHANT },
    ],
  };
}
export function getBlankHierarchyRowHpy(key) {
  return {
    key,
    selectedOrgIds: [],
    row: [
      { items: [], isLoading: false, selectedItems: [], tierName: 'chain', orgType: HPYOrgTypes.CHAIN },
      { items: [], isLoading: false, selectedItems: [], tierName: 'merchant', orgType: HPYOrgTypes.MERCHANT },
    ],
  };
}

export function getBlankHierarchyRowEvo(key) {
  return {
    key,
    selectedOrgIds: [],
    row: [
      { items: [], isLoading: false, selectedItems: [], tierName: 'group', orgType: EVOOrgTypes.GROUP },
      { items: [], isLoading: false, selectedItems: [], tierName: 'chain', orgType: EVOOrgTypes.CHAIN },
      { items: [], isLoading: false, selectedItems: [], tierName: 'tax_id', orgType: EVOOrgTypes.TAXID },
      { items: [], isLoading: false, selectedItems: [], tierName: 'merchant', orgType: EVOOrgTypes.MERCHANT },
    ],
  };
}

export function getBlankHierarchyRowGpe(key) {
  return {
    key,
    selectedOrgIds: [],
    row: [
      { items: [], isLoading: false, selectedItems: [], tierName: 'opco', orgType: GPEOrgTypes.OPCO },
      { items: [], isLoading: false, selectedItems: [], tierName: 'acquirer', orgType: GPEOrgTypes.ACQUIRER },
      { items: [], isLoading: false, selectedItems: [], tierName: 'contract', orgType: GPEOrgTypes.CONTRACT },
      { items: [], isLoading: false, selectedItems: [], tierName: 'merchant', orgType: GPEOrgTypes.MERCHANT },
    ],
  };
}